export default {
    TABLET: 'TABLET',
    PHONE: 'TELEFON',
    HOME: 'POČETNA STRANICA',
    CHECKOUT: 'PLAĆANJE',
    MENU: 'MENI',
    REGULAR: 'STANDARDNA',
    DISCOUNTED: 'SNIŽENA',
    DELIVERY: 'DOSTAVA',
    PICKUP: 'PREUZIMANJE',
    CASH: 'NOVAC',
    CARD: 'KARTICA',
};
